<script>
import Layout from "../../layouts/main";
import OrdersTab from "@/router/views/orders/ordersTab";
import InvoicesTab from "@/router/views/invoices/invoicesList"
import BeingValidationInvoices from "@/router/views/invoices/beingValidationInvoices"
import MovementTab from "@/router/views/orders/MovementTab"
import PendingValidationOrder from "@/router/views/orders/pendingValidationOrder"

import OrdersApi from "@/services/orders-api";
import InvoicesApi from "@/services/invoices-api";
import BackOrdersApi from "@/services/backOrders-api";
import AvoirRequestApi from "@/services/avoirRequest-api";
import ReportingApi from "@/services/reporting-api";
import { clearOrdersListState } from "@/ordersListState";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
/**
 * Orders-list component
 */
export default {
  beforeRouteEnter(to, from, next) {
    // Orders list filters/page are only restored when coming back from an order
    if (from.name !== 'Order') {
      clearOrdersListState()
    }
    next()
  },

    computed:{
        permission() {
             const  storedPermissions = JSON.parse(getCookie('permission')) || [];
          return storedPermissions
        },
        isPartner() {
         const  isPartner = JSON.parse(getCookie('isPartner')) || [];
        return isPartner
        },
        isCustomer() {
        return this.$cookies.get('userr') == 0;
        },
        isSupplier() {
        return this.$cookies.get('userr') == 1;
        },

        isAdmin() {
        return this.$cookies.get('userr') == 2;
        },
        isAddValidationOrderByCustomerEnabled(){
          return  process.env.VUE_APP_FEATURE_VALIDATION_PARTNER_ORDER_BY_CUSTOMER === 'true'
        },
        isMouvmenetItemEnabled(){
          return  process.env.VUE_APP_FEATURE_MOUVEMENT_ITEM === 'true'
        },

        isAvoirRequestEnabled(){
          return  process.env.VUE_APP_FEATURE_SHOW_AVOIR_REQUEST === 'true'
        },
        isBeingValidationInvoicesEnabled(){
          return  process.env.VUE_APP_FEATURE_BEING_VALIDATION_INVOICES === 'true'
        },
        isItemConsigneEnabled(){
          return  process.env.VUE_APP_FEATURE_ITEM_CONSIGNE === 'true'
        },
        // Omnipharm: segmented tab bar with one icon per document type
        isNewTabsEnabled(){
          return  process.env.VUE_APP_FEATURE_ORDERS_MENU_NEW_TABS === 'true'
        },
        role() {
          return this.$cookies.get('userr') ? this.$cookies.get('userr') : 0;
        },
        isAgencySupplier() {
        return this.$cookies.get('iss');
        },
    },

  mounted(){
    this.supplierAdmin= this.isSupplier && this.permission && this.permission.some(pr => pr.includes('SUPPLIER_ADMIN'));  
    this.hasOrdersListAccess= (this.isCustomer && this.permission && (this.permission.some(pr => pr.includes('ORDER_LIST')) || this.permission.some(pr => pr.includes('CUSTOMER_ADMIN')) )) 
                            || (this.isSupplier && this.permission && this.permission.some(pr => pr.includes('SUPPLIER_DOCUMENT_ACCESS'))) 
                            || this.isAdmin || this.supplierAdmin;  
    this.hasSupplierDocumentListAccess = (this.isSupplier && this.permission && this.permission.some(pr => pr.includes('SUPPLIER_DOCUMENT_ACCESS'))) 
                                        || this.isAdmin || this.supplierAdmin;  

  },

  components: {Layout,OrdersTab,InvoicesTab ,MovementTab,PendingValidationOrder, BeingValidationInvoices},
  data() {
    return { 
        backOrdersCount:0,
        ordersCount:0,
        invoicesCount:0,
        hasOrdersListAccess:false,
        hasSupplierDocumentListAccess:false,
        supplierAdmin:false,
        activeTabIndex:null
    };
  }, 

    methods: {
        countBackOrders(){
            BackOrdersApi.getBackOrdersCount().then(
                (result)=>{
                    if(result){
                        this.backOrdersCount=result
                    }else{
                        this.backOrdersCount=0
                    }
                    
                }
            )
        },
        countOrders(){
            OrdersApi.getOrdersCount(null).then(
                (result)=>{
                    if(result){
                        this.ordersCount=result
                    }else{
                        this.ordersCount=0

                    }
                }
            )
        },
        countInvoices(){
            InvoicesApi.getInvoicesCount(null).then(
                (result)=>{
                    if(result){
                        this.invoicesCount=result
                    }else{
                        this.invoicesCount=0
                    }
                }
            )
        },


        getInvoices (page, pageSize, customerId,status,start,end, type) {
            return InvoicesApi.getInvoices(page, pageSize, customerId,status,start,end, type);
        },

        getBLs (page, pageSize, customerId,status,start,end,type,dbAgencyId) {
            return InvoicesApi.getBLs(page, pageSize, customerId,status,start,end,type,dbAgencyId);
        },

        getAvoirs (page, pageSize, customerId,status,start,end,type, dbAgencyId) {
            return InvoicesApi.getAvoirs(page, pageSize, customerId,status,start,end,type, dbAgencyId);
        },
        getConsigneItems (page, pageSize, customerId) {
            return InvoicesApi.getConsigneList(page, pageSize, customerId);
        },
        getRequestAvoir (page, pageSize, customerId,status,start,end) {
            return AvoirRequestApi.getRequestAvoir(page, pageSize, customerId,status,start,end);
         },
        getDeliveredItemByCustomer (type ,  itemRef ,customerId) {
            return ReportingApi.getDeliveredItemByCustomer(type, itemRef, customerId);
         },


    }   ,   
    watch : {
        isAdmin: function() {},
        isSupplier: function(){},
    } 
    }

</script>
<template>
<Layout>
    <div class="row pt-4 p-sm-4 d-print-none">
        <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('ordersMenu.bigTitle')}}</h2>
                <p class="card-title-desc font-size-14">
                    {{ isSupplier && hasOrdersListAccess ? 'Commandes ' : 'Commandes, bons de livraisons, avoirs et factures'}}
                </p>
                <b-tabs :pills="isNewTabsEnabled" :nav-class="isNewTabsEnabled ? 'om-tabs' : 'nav-tabs-custom'" :nav-wrapper-class="isNewTabsEnabled ? 'om-tabs-wrap' : ''"  v-model="activeTabIndex" content-class="p-0 text-muted" :active-nav-item-class="isNewTabsEnabled ? '' : 'font-weight-bold text-uppercase '">
               
                <b-tab v-if="isAdmin || supplierAdmin || hasOrdersListAccess " active lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-cart" aria-hidden="true"></i><span>{{$t('ordersMenu.title')}}</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cart-plus font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-cart-plus font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('ordersMenu.title')}}</span>
                    </template>
                    </template>
                    <OrdersTab/>
                </b-tab>

                <b-tab v-if="permission.includes('CUSTOMER_ADMIN') || permission.includes('BON_LIV') || (isSupplier && hasSupplierDocumentListAccess && isPartner == false) || isAdmin || supplierAdmin" lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bxs-truck" aria-hidden="true"></i><span>Bons de livraison</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> BL
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16"> Bons de Livraison</span>
                    </template>
                    </template>
                    <InvoicesTab :withClaim="true" :displayExport="false" :displayAccusedModal="false" :isBlList="true" :api="this.getBLs" class="mt-4"/>
                </b-tab>

                 <b-tab v-if="permission.includes('CUSTOMER_ADMIN') || permission.includes('AVOIR') || (isSupplier && hasSupplierDocumentListAccess && isPartner == false)  || isAdmin || supplierAdmin" lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-undo" aria-hidden="true"></i><span>Bons de retour</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> BR
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Bons de Retour</span>
                    </template>
                    </template>
                    <InvoicesTab :displayExport="false" :displayAccusedModal="false"  :isAvoirList="true" :api="this.getAvoirs" class="mt-4"/>
                </b-tab>

                <b-tab v-if="permission.includes('CUSTOMER_ADMIN') || permission.includes('INVOICE') || (isSupplier && hasSupplierDocumentListAccess && isPartner == false )  || isAdmin || supplierAdmin" lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-receipt" aria-hidden="true"></i><span>{{$t('invoicesMenu.title')}}</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> F
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('invoicesMenu.title')}}</span>
                    </template>
                    </template>
                    
                    <InvoicesTab :displayExport="true" :displayAccusedModal="true" :isInvoiceList="true"  :withHoldingColumn="true" :api="this.getInvoices" class="mt-4"/>
                </b-tab>

                <!-- supplier-only (like /api/invoices/being-validation/*, which refuses CUSTOMER users): pharmacies also hold INVOICE -->
                <b-tab v-if=" !isAgencySupplier && isBeingValidationInvoicesEnabled && ( (isSupplier && permission.includes('INVOICE')) || (isSupplier && hasSupplierDocumentListAccess && isPartner == false )  || isAdmin || supplierAdmin)" lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-hourglass" aria-hidden="true"></i><span>Factures en attente de validation</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> F
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('invoicesMenu.title2')}}</span>
                    </template>
                    </template>
                    
                    <BeingValidationInvoices class="mt-4"/>
                </b-tab>


                <b-tab v-if=" isAvoirRequestEnabled && ( permission.includes('CUSTOMER_ADMIN') || permission.includes('AVOIR') || (isSupplier && hasSupplierDocumentListAccess && isPartner == false) || isAdmin || supplierAdmin )" lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-message-square-dots" aria-hidden="true"></i><span>Demandes d'avoir</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> D AV
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('avoir.title')}}</span>
                    </template>
                    </template>
                    <InvoicesTab :displayExport="false" :displayAccusedModal="false" :api="this.getRequestAvoir" :isAvoirDetailsButton="true"   :withHoldingColumn="true"  class="mt-4"/>
 
                </b-tab>

                <!-- right after Demandes d'avoir; Recherche de mouvements stays last -->
                <b-tab v-if="isItemConsigneEnabled && (permission.includes('CUSTOMER_ADMIN') || (isSupplier && hasSupplierDocumentListAccess && isPartner == false) || isAdmin || supplierAdmin)" lazy>
                    <template v-slot:title>
                        <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-package" aria-hidden="true"></i><span>Articles consignés</span></span>
                        <template v-else>
                        <span class="d-inline-block d-sm-none">
                            <i class="far fa-file-alt font-size-16"></i> C
                        </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Articles consignés</span>
                        </template>
                    </template>
                    <InvoicesTab :displayExport="false" :displayAccusedModal="false" :isConsigneList="true" :api="this.getConsigneItems" class="mt-4"/>
                </b-tab>


                <b-tab v-if="(hasSupplierDocumentListAccess || (!isSupplier && (permission.includes('CUSTOMER_ADMIN') || permission.includes('BON_LIV') || ( isPartner == false) ))) && isMouvmenetItemEnabled " lazy>
                    <template v-slot:title>
                    <span v-if="isNewTabsEnabled" class="om-tab"><i class="bx bx-transfer-alt" aria-hidden="true"></i><span>Recherche de mouvements</span></span>
                    <template v-else>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-file-alt font-size-16"></i> Recherche de Mouvements
                    </span>
                    <i class="d-none d-sm-inline-block far fa-file-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">  Recherche de Mouvements</span>
                    </template>
                    </template>
                    <MovementTab :displayExport="false" :displayAccusedModal="false" :api="this.getDeliveredItemByCustomer" class="mt-4"/>
                </b-tab>
               

                </b-tabs>
            </div>
        </div>
      </div>

      <div class="col-lg-12 mt-4" v-if="isAddValidationOrderByCustomerEnabled && activeTabIndex == 0">
        <div class="card">
            <div class="card-body">
                <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('ordersMenu.partnerOrder')}}</h2>
                <PendingValidationOrder/>

            </div>
        </div>
      </div>
    </div>
</Layout>
</template>

<style>
/* Omnipharm tab bar (VUE_APP_FEATURE_ORDERS_MENU_NEW_TABS); b-tabs renders the nav itself, so these rules are not scoped */
.om-tabs-wrap { margin: .75rem 0 .25rem; }
.om-tabs.nav { flex-wrap: nowrap; gap: .25rem; width: max-content; max-width: 100%; padding: .3rem; overflow-x: auto; background: #f2f4f7; border-radius: 12px; scrollbar-width: none; -webkit-overflow-scrolling: touch; }
.om-tabs.nav::-webkit-scrollbar { display: none; }
.om-tabs.nav .nav-item { flex: 0 0 auto; padding: 0; }
.om-tabs.nav-pills .nav-link { display: flex; align-items: center; padding: .5rem .9rem; border-radius: 9px; color: #475467; font-size: 14px; font-weight: 600; white-space: nowrap; background: transparent; transition: background-color .15s ease, color .15s ease, box-shadow .15s ease; }
.om-tabs.nav-pills .nav-link:hover { color: #101828; background: rgba(255, 255, 255, .65); }
.om-tabs.nav-pills .nav-link.active { color: #101828; background: #fff; box-shadow: 0 1px 2px rgba(16, 24, 40, .08), 0 1px 3px rgba(16, 24, 40, .1); }
.om-tabs.nav-pills .nav-link:focus-visible { outline: 2px solid #344054; outline-offset: 2px; }
.om-tab { display: inline-flex; align-items: center; gap: .45rem; }
.om-tab .bx { font-size: 18px; color: #667085; }
.om-tabs.nav-pills .nav-link.active .om-tab .bx { color: #101828; }
@media (prefers-reduced-motion: reduce) { .om-tabs.nav-pills .nav-link { transition: none; } }
</style>
